//an object of arrays filled with css positions
export const floaterPositions = {
  desktop: [
    {
      capsule: {
        top: "10%",
        left: "7%"
      }
    },
    {
      capsule: {
        top: "50%",
        left: "18%",
        zIndex: "3"
      }
    },
    {
      capsule: {
        top: "25%",
        left: "45%",
        zIndex: "2"
      }
    },
    {
      capsule: {
        top: "20px",
        right: "22%"
      }
    },
    {
      capsule: {
        top: "52%",
        right: "17%"
      }
    }
  ],

  mobile: [
    {
      capsule: {
        left: "7%",
        zIndex: "3"
      },
      preview: {
        top: "46px",
        right: "-94px"
      }
    },
    {
      capsule: {
        bottom: "18%",
        left: "13%",
        zIndex: "3"
      }
    },
    {
      capsule: {
        top: "28%",
        left: "36%",
        zIndex: "2"
      }
    },
    {
      capsule: {
        top: "5%",
        right: "10%",
        zIndex: "1"
      },
      preview: {
        top: "-2px",
        right: "67px"
      }
    },
    {
      capsule: {
        bottom: "10%",
        right: "10%",
        zIndex: "4"
      },
      preview: {
        top: "-5px",
        right: "19px"
      }
    }
  ]
};
